import { z } from 'zod';

export const coreWebVitalsFormSchema = z.object({
  url: z.string().transform(val => {
    const cleaned = val.replace(/\s/g, '');

    if (!cleaned.startsWith('http://') && !cleaned.startsWith('https://')) {
      return `https://${cleaned}`;
    }

    return cleaned;
  }),
});
